import { jsx as i } from "react/jsx-runtime";
import c from "../components/comments/Comments.js";
import { COMMENTER_ROOT as p } from "./popups.js";
const s = async (o, r, t, m, e, n, a) => {
  p.render(
    /* @__PURE__ */ i(
      c,
      {
        submitCallback: r,
        cancelCallback: t,
        text: o,
        btnText: e,
        placeholder: m,
        title: n,
        subTitle: a
      }
    )
  );
}, f = async (o, r, t = "", m, e, n) => {
  await s(t, o, r, void 0, n, m, e);
}, g = async (o, r, t = "", m, e) => {
  await s(t, o, r, m, e);
};
export {
  f as showCommenter,
  g as showFeedbackDialog
};
